import React, { useEffect, useState } from 'react';
import './DataAndDocsTab.scss';
import Helpers from '../../../utils/helper';
import filterFactory from '../../../components/react-bootstrap-table-next/react-bootstrap-table2-filter';
import BootstrapTable, {
    TableChangeState,
    TableChangeType,
} from '../../../components/react-bootstrap-table-next/react-bootstrap-table2';
import { Button } from 'reactstrap';
import { LinkedDataRequestProject } from '../../../slices/marketplace/timeline/models/linked-data-request-project.model';
import { CreateDataAndDocsModal } from './CreateDataAndDocsModal/CreateDataAndDocsModal';
import { useStateSelector } from '../../../store/selectors';
import { GetTimelineByPracticeId } from '../../../slices/marketplace/timeline/thunks/get-timeline-by-practice-id.thunk';
import { useDispatch } from 'react-redux';
import { useCurrentMarketplaceParty } from '../../../custom-hooks/useCurrentMarketplaceParty';
import { TimelineParty } from '../../../slices/marketplace/timeline/models/enums/timeline-party.enum';

interface DataAndDocsTabProps {
    engagementId: number;
    practiceId: number;
}
export const DataAndDocsTab = (props: DataAndDocsTabProps) => {
    const dispatch = useDispatch() as any;
    const party = useCurrentMarketplaceParty();
    const [isLoading, setIsLoading] = React.useState(true);
    const [projects, setProjects] = React.useState<LinkedDataRequestProject[]>(
        []
    );
    const currentEngagement = useStateSelector(
        (state) => state.timelines.currentTimeline
    );
    const defaultSorted: [{ dataField: any; order: any }] = [
        {
            dataField: 'name',
            order: 'asc',
        },
    ];
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

    const tableColumns = [
        {
            dataField: 'projectName',
            text: 'Request Name',
            headerClasses: 'project-name-column-header',
            sort: true,
            formatter: (cellContent: number) => {
                return (
                    <div
                        className="link-button"
                        onClick={() => {
                            // Handle click event for project name
                        }}>
                        {cellContent}
                    </div>
                );
            },
        },
        {
            dataField: 'dateCreated',
            text: 'Date Created',
            headerClasses: 'date-created-column-header',
            sort: true,
            formatter: (cellContent: string | Date) => {
                return <div>{new Date(cellContent).toLocaleDateString()}</div>;
            },
        },
        {
            dataField: '',
            text: 'Deadline Date',
            headerClasses: 'deadline-date-column-header',
            sort: true,
            formatter: (id: string, proj: LinkedDataRequestProject) => {
                return <div>{new Date(/* */).toLocaleDateString()}</div>;
            },
        },
        {
            dataField: '',
            text: 'Status',
            headerClasses: 'deadline-date-column-header',
            sort: true,
            formatter: (id: string, proj: LinkedDataRequestProject) => {
                return <div>Status</div>;
            },
        },
        {
            dataField: 'id',
            text: 'Action',
            headerClasses: 'action-column-header',
            sort: true,
            formatter: (
                cellContent: string,
                proj: LinkedDataRequestProject
            ) => {
                return <div>Action</div>;
            },
        },
    ];

    const handleTableChange = (
        type: TableChangeType,
        newState: TableChangeState<any>
    ) => {
        console.log('Table change:', type, newState);
    };

    useEffect(() => {
        if (currentEngagement) {
            setIsLoading(true);
            setProjects(currentEngagement.engagementData.dataRequestProjects);
            setIsLoading(false);
        }
    }, [currentEngagement]);

    return (
        <div className="data-and-docs-tab">
            <div className="body_inner_content">
                <div className="obpbq_row valuation_section">
                    <div className="sampledetail">
                        <div className="mb-2 d-flex justify-content-between align-items-center">
                            <strong>Practice Data & Docs</strong>
                            {party === TimelineParty.VetValue ? (
                                <Button
                                    color="primary"
                                    onClick={() => setIsCreateModalOpen(true)}>
                                    Add practice Data & Docs
                                </Button>
                            ) : (
                                []
                            )}
                        </div>
                        <div
                            role="tabpanel"
                            id="panel-0"
                            aria-labelledby="tab-0"
                            aria-hidden="false">
                            <div className="card-body">
                                {isLoading ? (
                                    Helpers.renderTableLoader()
                                ) : (
                                    <BootstrapTable
                                        striped
                                        bordered
                                        bootstrap4
                                        remote
                                        keyField="id"
                                        data={projects}
                                        columns={tableColumns}
                                        defaultSorted={defaultSorted}
                                        filter={filterFactory()}
                                        onTableChange={handleTableChange}
                                        noDataIndication="No Data & Docs Projects available"
                                        rowStyle={{ height: '44px' }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isCreateModalOpen ? (
                <CreateDataAndDocsModal
                    engagementId={props.engagementId}
                    isVisible={isCreateModalOpen}
                    onClose={() => setIsCreateModalOpen(false)}
                    onSubmit={() => {
                        dispatch(GetTimelineByPracticeId(props.practiceId))
                            .then()
                            .finally(() => {
                                setIsLoading(false);
                            });
                        setIsCreateModalOpen(false);
                    }}
                />
            ) : (
                []
            )}
        </div>
    );
};
